// sendRAGRequest.js

import axios from 'axios'; // Import axios to make HTTP requests

// Function to send RAG request
export const sendRAGRequest = async (question, memory, language, isSimplifiedMode) => {
    try {
        let translatedQuestion = question;
        let translatedMemory = memory;
        let retriever_type=1;
        let sourcesRequested=false;

        // Check if the question ends with 'r=2' or 'r=1'
        if (question.endsWith('r=2')) {
            retriever_type = 2;
            translatedQuestion = question.slice(0, -3).trim(); // Remove the last 3 characters and trim whitespace
            sourcesRequested=true;
        } else if (question.endsWith('r=1')) {
            retriever_type = 1;
            translatedQuestion = question.slice(0, -3).trim(); // Remove the last 3 characters and trim whitespace
            sourcesRequested=true;
        }


        console.log(`Line 25: ${translatedQuestion}, ${translatedMemory}, ${language}, ${isSimplifiedMode}`)

        // Check if the current language is not Dutch and translate the question and memory
        if (language !== 'dutch') {
            console.log('translateing from ', language, 'to dutch')
            // Translate the question
            const translationResponseQuestion = await axios.post(
                'https://us-central1-chatbot-418311.cloudfunctions.net/translate',
                {
                    language_from: language,
                    language_to: 'dutch',
                    text: question,
                },
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            translatedQuestion = translationResponseQuestion.data.translated_text;

            // Translate the memory
            const translationResponseMemory = await axios.post(
                'https://us-central1-chatbot-418311.cloudfunctions.net/translate',
                {
                    language_from: language,
                    language_to: 'dutch',
                    text: memory,
                },
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            translatedMemory = translationResponseMemory.data.translated_text;
        }

        // Send the RAG request
        const response = await axios.post(
            'https://rag-chatbot-europe-459709207650.europe-west4.run.app/chat',
            {
                question: translatedQuestion,
                memory: translatedMemory,
                retriever_type: retriever_type,
                is_simplified: isSimplifiedMode
            },
            {
                headers: { 'Content-Type': 'application/json' },
            }
        );

        let finalAnswer = response.data.answer;
        let sourcesUsed = response.data.sources_used;

        // Translate the response back to the original language if it's not English
        if (language !== 'dutch') {
            const translationResponseAnswer = await axios.post(
                'https://us-central1-chatbot-418311.cloudfunctions.net/translate',
                {
                    language_from: 'dutch',
                    language_to: language,
                    text: finalAnswer,
                },
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            finalAnswer = translationResponseAnswer.data.translated_text;
        }

        console.log(`Final answer is: ${finalAnswer}`);

        return { answer: finalAnswer, sources: sourcesUsed, sourcesRequested: sourcesRequested};
    } catch (error) {
        console.error('Error making RAG API call:', error);
        return null;
    }
};
